// Lazy load function
const lazyLoad = (file) => () => import(/* webpackChunkName: "[request]" */ `@/views/sales/${file}.vue`);

export default [
    {
        path: "/sales-order",
        name: "sales-order-list",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "SalesOrder",
        },
        components: {
            content: lazyLoad('sales-order-list'),
        },
    },
    // Desktop Sales Order - NEW - Based on Touch SO
    {
        path: "/sales-order/create*",
        name: "sales-order-create",
        meta: { requiresAuth: true, applicationFeatureCode: "SalesOrder" },
        components: {
            content: lazyLoad('sales-order'),
        },
    },
    {
        path: "/sales-order/edit/:id*",
        name: "sales-order-edit",
        meta: { requiresAuth: true, applicationFeatureCode: "SalesOrder" },
        components: {
            content: lazyLoad('sales-order'),
        },
    },
    {
        path: "/sales-order/review/:id*",
        name: "sales-order-review",
        meta: { requiresAuth: true, applicationFeatureCode: "SalesOrder" },
        components: {
            content: lazyLoad('sales-order'),
        },
    },

    {
        path: "/almondco-inshell-sales-order-lot-assignment/edit/:id",
        name: "almondco-inshell-sales-order-lot-assignment-edit",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "AlmondcoInshellSalesOrderLotAssignment",
        },
        components: {
            content: lazyLoad('almondco-inshell-sales-order-lot-assignment'),
        },
    },
    {
        path: "/almondco-inshell-sales-order-lot-assignment/review/:id",
        name: "almondco-inshell-sales-order-lot-assignment-review",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "AlmondcoInshellSalesOrderLotAssignment",
        },
        components: {
            content: lazyLoad('almondco-inshell-sales-order-lot-assignment'),
        },
    },

    {
        path: "/despatch-order",
        name: "despatch-order-list",
        meta: { requiresAuth: true, applicationFeatureCode: "OrderPicking" },
        components: {
            content: lazyLoad('despatch-order-list'),
        },
    },

    {
        path: "/despatch-order/review/:id*",
        name: "despatch-order-review",
        meta: { requiresAuth: true, applicationFeatureCode: "OrderPicking" },
        components: {
            content: lazyLoad('despatch-order'),
        },
    },
    {
        path: "/despatch-order/edit/:id*",
        name: "despatch-order-edit",
        meta: { requiresAuth: true, applicationFeatureCode: "OrderPicking" },
        components: {
            content: lazyLoad('despatch-order'),
        },
    },

    {
        path: "/despatched",
        name: "despatched-list",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "OrderPicking",
        },
        components: {
            content: lazyLoad('despatched-list'),
        },
    },

    {
        path: "/delivery-note/review/:id",
        name: "delivery-note-review",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "OrderPicking",
        },
        components: {
            content: lazyLoad('delivery-note'),
        },
    },

    {
        path: "/manifest-order",
        name: "manifest-order",
        meta: { requiresAuth: true, applicationFeatureCode: "ManifestOrder" },
        components: {
            content: lazyLoad('manifest-order'),
        },
    },
    {
        path: "/manifest-order/:tab*",
        name: "manifest-order-tab",
        meta: { requiresAuth: true, applicationFeatureCode: "ManifestOrder" },
        components: {
            content: lazyLoad('manifest-order'),
        },
    },

    {
        path: "/pending-invoice",
        name: "pending-invoice-list",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "Invoice",
        },
        components: {
            content: lazyLoad('pending-invoice-list'),
        },
    },

    {
        path: "/invoiced-order",
        name: "invoiced-order-list",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "Invoice",
        },
        components: {
            content: lazyLoad('invoiced-order-list'),
        },
    },

    {
        path: "/invoice/create/:id*",
        name: "invoice-create",
        meta: { requiresAuth: true, applicationFeatureCode: "Invoice" },
        components: {
            content: lazyLoad('invoice-v2'),
        },
    },
    {
        path: "/invoice/review/:id*",
        name: "invoice-review",
        meta: { requiresAuth: true, applicationFeatureCode: "Invoice" },
        components: {
            content: lazyLoad('invoice'),
        },
    },
    {
        path: "/invoice/edit/:id*",
        name: "invoice-edit",
        meta: { requiresAuth: true, applicationFeatureCode: "Invoice" },
        components: {
            content: lazyLoad('invoice-v2'),
        },
    },

    {
        path: "/sales-order-profit-enquiry",
        name: "sales-order-profit-enquiry",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "SalesOrderEnquiry",
        },
        components: {
            content: lazyLoad('sales-order-profit-enquiry-list'),
        },
    },
    {
        path: "/sales-order-profit-enquiry/:id",
        name: "sales-order-profit-enquiry-review",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "SalesOrderEnquiry",
        },
        components: {
            content: lazyLoad('sales-order-profit-enquiry'),
        },
    },

    {
        path: "/sales-contract",
        name: "sales-contract-list",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "CustomerSalesContract",
        },
        components: {
            content: lazyLoad('sales-contract-list'),
        },
    },
    {
        path: "/sales-contract/create",
        name: "sales-contract-create",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "CustomerSalesContract",
        },
        components: {
            content: lazyLoad('sales-contract'),
        },
    },
    {
        path: "/sales-contract/edit/:id*",
        name: "sales-contract-edit",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "CustomerSalesContract",
        },
        components: {
            content: lazyLoad('sales-contract'),
        },
    },
    {
        path: "/sales-contract/review/:id*",
        name: "sales-contract-review",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "CustomerSalesContract",
        },
        components: {
            content: lazyLoad('sales-contract'),
        },
    },

    {
        path: "/sales-contract-balance",
        name: "sales-contract-balance-list",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "ReportCustomerSalesContractBalance",
        },
        components: {
            content: lazyLoad('sales-contract-balance-list'),
        },
    },

    {
        path: "/price-group",
        name: "price-group-list",
        meta: { requiresAuth: true, applicationFeatureCode: "PriceGroup" },
        components: {
            content: lazyLoad('price-group-list'),
        },
    },
    {
        path: "/price-group/create*",
        name: "price-group-create",
        meta: { requiresAuth: true, applicationFeatureCode: "PriceGroup" },
        components: {
            content: lazyLoad('price-group'),
        },
    },
    {
        path: "/price-group/edit/:id*",
        name: "price-group-edit",
        meta: { requiresAuth: true, applicationFeatureCode: "PriceGroup" },
        components: {
            content: lazyLoad('price-group'),
        },
    },
    {
        path: "/price-group/review/:id*",
        name: "price-group-review",
        meta: { requiresAuth: true, applicationFeatureCode: "PriceGroup" },
        components: {
            content: lazyLoad('price-group'),
        },
    },

    {
        path: "/item-price-update",
        name: "item-price-update",
        meta: { requiresAuth: true, applicationFeatureCode: "ItemPriceUpdate" },
        components: {
            content: lazyLoad('item-price-update'),
        },
    },
    {
        path: "/item-price-update/review/:id*",
        name: "item-price-update-review",
        meta: { requiresAuth: true, applicationFeatureCode: "ItemPriceUpdate" },
        components: {
            content: lazyLoad('item-price-update'),
        },
    },
    {
        path: "/item-price-update/edit/:id*",
        name: "item-price-update-edit",
        meta: { requiresAuth: true, applicationFeatureCode: "ItemPriceUpdate" },
        components: {
            content: lazyLoad('item-price-update'),
        },
    },

    {
        path: "/sell-price-product",
        name: "sell-price-product",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "SellPricesbyProduct",
        },
        components: {
            content: lazyLoad('sell-price-product'),
        },
    },

    {
        path: "/almondco-inshell-dispatch-sales-order",
        name: "almondco-inshell-dispatch-sales-order",
        meta: { requiresAuth: true },
        components: {
            content: lazyLoad('almondco-inshell-dispatch-sales-order'),
        },
    },

    {
        path: "/sales-order-edi/:id",
        name: "sales-order-edi",
        meta: { requiresAuth: true, applicationFeatureCode: "SalesOrderEDI" },
        components: {
            content: lazyLoad('sales-order-edi'),
        },
    },

    {
        path: "/sales-by-customer",
        name: "sales-by-customer",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "SalesByCustomer",
        },
        components: {
            content: lazyLoad('sales-by-customer'),
        },
    },

    {
        path: "/sales-order-old/create*",
        name: "sales-order-create-old",
        meta: { requiresAuth: true, applicationFeatureCode: "SalesOrder" },
        components: {
            content: lazyLoad('sales-order-old'),
        },
    },
    {
        path: "/sales-order-old/edit/:id*",
        name: "sales-order-edit",
        meta: { requiresAuth: true, applicationFeatureCode: "SalesOrder" },
        components: {
            content: lazyLoad('sales-order-old'),
        },
    },
    {
        path: "/sales-order-old/review/:id*",
        name: "sales-order-review",
        meta: { requiresAuth: true, applicationFeatureCode: "SalesOrder" },
        components: {
            content: lazyLoad('sales-order-old'),
        },
    },

    {
        path: "/sales-order-v2/create*",
        name: "sales-order-create-v2",
        meta: { requiresAuth: true, applicationFeatureCode: "SalesOrderV2" },
        components: {
            content: lazyLoad('sales-order-v2'),
        },
    },
    {
        path: "/sales-order-v2/edit/:id*",
        name: "sales-order-edit-v2",
        meta: { requiresAuth: true, applicationFeatureCode: "SalesOrderV2" },
        components: {
            content: lazyLoad('sales-order-v2'),
        },
    },
    {
        path: "/sales-order-v2/review/:id*",
        name: "sales-order-review-v2",
        meta: { requiresAuth: true, applicationFeatureCode: "SalesOrderV2" },
        components: {
            content: lazyLoad('sales-order-v2'),
        },
    },

    // Sales Order V3
    {
        path: "/sales-order-v3/create*",
        name: "sales-order-create-v3",
        meta: { requiresAuth: true, applicationFeatureCode: "SalesOrderV2" },
        components: {
            content: lazyLoad('sales-order-v3'),
        },
    },
    {
        path: "/sales-order-v3/edit/:id*",
        name: "sales-order-edit-v3",
        meta: { requiresAuth: true, applicationFeatureCode: "SalesOrderV2" },
        components: {
            content: lazyLoad('sales-order-v3'),
        },
    },
    {
        path: "/sales-order-v3/review/:id*",
        name: "sales-order-review-v3",
        meta: { requiresAuth: true, applicationFeatureCode: "SalesOrderV2" },
        components: {
            content: lazyLoad('sales-order-v3'),
        },
    },

    // Sales Order V4
    {
        path: "/sales-order-v4/create*",
        name: "sales-order-create-v4",
        meta: { requiresAuth: true, applicationFeatureCode: "SalesOrderV2" },
        components: {
            content: lazyLoad('sales-order-v4'),
        },
    },
    {
        path: "/sales-order-v4/edit/:id*",
        name: "sales-order-edit-v4",
        meta: { requiresAuth: true, applicationFeatureCode: "SalesOrderV2" },
        components: {
            content: lazyLoad('sales-order-v4'),
        },
    },
    {
        path: "/sales-order-v4/review/:id*",
        name: "sales-order-review-v4",
        meta: { requiresAuth: true, applicationFeatureCode: "SalesOrderV2" },
        components: {
            content: lazyLoad('sales-order-v4'),
        },
    },

    // Sales Order V5
    {
        path: "/sales-order-v5/create*",
        name: "sales-order-create-v5",
        meta: { requiresAuth: true, applicationFeatureCode: "SalesOrderV2" },
        components: {
            content: lazyLoad('sales-order-v5'),
        },
    },
    {
        path: "/sales-order-v5/edit/:id*",
        name: "sales-order-edit-v5",
        meta: { requiresAuth: true, applicationFeatureCode: "SalesOrderV2" },
        components: {
            content: lazyLoad('sales-order-v5'),
        },
    },
    {
        path: "/sales-order-v5/review/:id*",
        name: "sales-order-review-v5",
        meta: { requiresAuth: true, applicationFeatureCode: "SalesOrderV2" },
        components: {
            content: lazyLoad('sales-order-v5'),
        },
    },

    {
        path: "/despatch-order-v2/review/:id*",
        name: "despatch-order-review-v2",
        meta: { requiresAuth: true, applicationFeatureCode: "OrderPicking" },
        components: {
            content: lazyLoad('despatch-order-v2'),
        },
    },
    {
        path: "/despatch-order-v2/edit/:id*",
        name: "despatch-order-edit-v2",
        meta: { requiresAuth: true, applicationFeatureCode: "OrderPicking" },
        components: {
            content: lazyLoad('despatch-order-v2'),
        },
    },

    {
        path: "/invoice-activation/review/:id*",
        name: "invoice-activation-review",
        meta: { requiresAuth: true, applicationFeatureCode: "Invoice" },
        components: {
            content: lazyLoad('invoice-activation'),
        },
    },
    {
        path: "/invoice-activation/edit/:id*",
        name: "invoice-activation-edit",
        meta: { requiresAuth: true, applicationFeatureCode: "Invoice" },
        components: {
            content: lazyLoad('invoice-activation'),
        },
    },
    {
        path: "/credit-invoice/create*",
        name: "invoice-credit-create",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "Invoice",
        },
        components: {
            content: lazyLoad('invoice-credit'),
        },
    },
    {
        path: "/credit-invoice/review/:id",
        name: "invoice-credit-review",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "Invoice",
        },
        components: {
            content: lazyLoad('invoice-credit'),
        },
    },

    {
        path: "/sales-quote/review/:id",
        name: "sales-quote-review",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "SalesOrderEnquiry",
        },
        components: {
            content: lazyLoad('sales-quote'),
        },
    },
    {
        path: "/work-order/review/:id",
        name: "work-order-review",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "SalesOrderEnquiry",
        },
        components: {
            content: lazyLoad('work-order'),
        },
    },

]; 